import { loginByUsername, logout, getUserInfo, getSystemTime, selectDisVerificationCode, getVerificationCodeImg, getVerificationCodeData, selectUserBindRoleByUserId,selectPriCloudTimeInfo} from '@/api/login'
import { getToken, setToken, removeToken,setSysTime,getSysTime,removeSysTime, getVerificationCode,setVerificationCode,
  removeVerificationCode,getAvatar,setAvatar,setRoletype,getRoletype,setIsManage,getIsManage,getDiskPath,setDiskPath,removeDiskPath,getUserStatus ,getThirdUrl} from '@/utils/auth'
//加载密码加密js
import { hex_sha1 } from '@/common/js/ha1'
import permission from '../../views/permission/permission'
import {recordBehaviorsAfter} from "../../monitoring/performanceMonitoring";
import $router from '@/router'
import {getEndOrgName, getUserName, setEndOrgName, setUserName} from "../../utils/auth";

let _this = this
const user = {
  state: {
    userName:getUserName(),
    endOrgName:getEndOrgName(),
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    systemtime:getSysTime(),
    avatar:getAvatar(),
    verificationCode:getVerificationCode(),
    roletype:getRoletype(),
    isManage:getIsManage(),
    userStatus:getUserStatus(),
    thirdUrl:getThirdUrl()
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SYS_TEMTIME: (state, systemtime) => {
      //获取系统时间
      state.systemtime = systemtime
    },
    SYS_DISKPATH:(state, sysdiskpath) => {
      //获取系统时间
      state.sysdiskpath = sysdiskpath
      setDiskPath(sysdiskpath)
    },
    SET_AVATAR:(state, avatar) => {
      //获取系统时间
      state.avatar = avatar
      setAvatar(avatar)
    },
    SET_ISMANAGE:(state, isManage) => {
      //获取系统时间
      state.isManage = isManage
      setIsManage(isManage)
    },
    SET_VERIFICATIONCODE:(state, verificationCode) => {
      //获取系统时间
      state.verificationCode = verificationCode
      setVerificationCode(verificationCode)
    },
    SET_ROLETYPE:(state, roletype) => {
      //获取系统时间
      state.roletype = roletype
      setRoletype(roletype)
    },
    SET_USERNAME:(state, userName) =>{
      //获取系统时间
      state.userName = userName
      setUserName(userName)
    },
    SET_ENDORGNAME:(state, endOrgName) =>{
      //获取系统时间
      state.endOrgName = endOrgName
      setEndOrgName(endOrgName)
    },
  },

  actions: {
    //获取验证码
    selectDisVerificationCode({ commit }, userInfo) {
      const username = userInfo.username.trim()
      let jsonBody = {userName: username}
      return new Promise((resolve, reject) => {
        selectDisVerificationCode({jsonBody:jsonBody}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // getVerificationCodeImg({ commit }, userInfo){
    //   // const username = userInfo.username.trim()
    //   return new Promise((resolve, reject) => {
    //     // let jsonBody = {userName: username}
    //     getVerificationCodeImg().then(response => {
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    getVerificationCodeData({ commit }, userInfo){
      return new Promise((resolve, reject) => {
        // let jsonBody = {userName: username}
        getVerificationCodeData().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        let password_sha = hex_sha1( userInfo.password )
        let jsonBody = {userName: username,userPwd:password_sha,verCode:userInfo.verCode,verKeyCode:getVerificationCode()}
        loginByUsername({jsonBody:jsonBody}).then(response => {
          let rtnCode = response.jsonBody.rtnCode
          if(rtnCode == 0){
            if(response.jsonBody.msgBody.isManage == 0){

            }else {
              const data = response.jsonBody.msgBody
              commit('SET_TOKEN', data.accessToken)
              commit('SET_AVATAR', data.userHeadImg)
              commit('SET_ROLETYPE', data.userStyle)
              commit('SET_ISMANAGE', data.isManage)
              commit('SET_USERNAME', data.userName)
              commit('SET_ENDORGNAME', data.endOrgName)
              setToken(data.accessToken)
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data

          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }

          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetSystemTime({ commit, state }) {
      return new Promise((resolve, reject) => {
        getSystemTime({}).then(res => {
          let jsonBodyData = res.jsonBody
          commit('SYS_TEMTIME', jsonBodyData.msgBody.dateTime)//存储系统时间
          setSysTime(jsonBodyData.msgBody.dateTime)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    selectPriCloudTimeInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        selectPriCloudTimeInfo({}).then(res => {
          let jsonBodyData = res.jsonBody
          commit('SYS_DISKPATH', jsonBodyData.msgBody)//存储系统事件
          setDiskPath(jsonBodyData.msgBody)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    selectUserBindRoleByUserId({ commit, state }){  //权限
      return new Promise((resolve, reject) => {
        selectUserBindRoleByUserId({}).then(res => {
          let jsonBodyData = res.jsonBody
          let codes = jsonBodyData.msgBody.codes
          if(state.roletype == 1 || state.roletype == 0){

          }else {

          }
          // if(state.roletype == 1 || state.roletype == 0){


            // codes.forEach(function (item, index) {
            //   if(permission.componentModule[item] == undefined){
            //
            //   }else {
            //     permission.componentModule[item].hidden = false
            //   }
            // })



          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = true
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = false
          // }else if(state.roletype == 2){
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = false
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = true
          // }else {
          //   codes.forEach(function (item, index) {
          //     if(permission.componentModule[item] == undefined){
          //     }else {
          //       permission.componentModule[item].hidden = false
          //     }
          //   })
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = true
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = false
          // }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {

      return new Promise((resolve, reject) => {
        recordBehaviorsAfter($router.history.current).then(() => {
          logout(state.token).then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            localStorage.removeItem("router");
            removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(err => {
          console.log('err',err)
        });
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js